export const initialState = {
  favoriteRecipesList: { recipes: [] },
  isLoading: false,
  error: null,
};
